function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { createRenderer } from 'fela';
import rtl from 'fela-plugin-rtl';
import hexToRgba from 'hex-to-rgba';
import sortClassnames from 'fela-sort-classnames';
import sortMediaQueryMobileFirst from 'fela-sort-media-query-mobile-first';
import responsiveValue from 'fela-plugin-responsive-value';
import themeValue from 'fela-plugin-theme-value';
import extend from 'fela-plugin-extend';
import embedded from 'fela-plugin-embedded';
import prefixer from 'fela-plugin-prefixer';
import falllbackValue from 'fela-plugin-fallback-value';
import unit from 'fela-plugin-unit';
import namedKeys from 'fela-plugin-named-keys';
import { assignStyle } from 'css-in-js-utils';
import { mapValueToMediaQuery } from 'fela-tools'; // whitelisting all the props that support responsive array values

export var responsiveProps = {
  padding: true,
  paddingLeft: true,
  paddingRight: true,
  paddingBottom: true,
  paddingTop: true,
  margin: true,
  marginLeft: true,
  marginRight: true,
  marginBottom: true,
  marginTop: true,
  width: true,
  height: true,
  minWidth: true,
  minHeight: true,
  maxWidth: true,
  maxHeight: true,
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  alignSelf: true,
  alignItems: true,
  alignContent: true,
  justifyContent: true,
  flexDirection: true,
  flexWrap: true,
  order: true,
  display: true
};

var getResponsiveMediaQueries = function getResponsiveMediaQueries(values, props) {
  var _props$theme$breakpoi = props.theme.breakpoints,
      fromM = _props$theme$breakpoi.fromM,
      fromL = _props$theme$breakpoi.fromL,
      fromXL = _props$theme$breakpoi.fromXL;
  var mediaQueryMap = {
    2: [fromM],
    3: [fromM, fromL],
    4: [fromM, fromL, fromXL]
  };
  return mediaQueryMap[values.length];
};

export function styleRenderer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isRtl = _ref.isRtl,
      rest = _objectWithoutProperties(_ref, ["isRtl"]);

  var options = rest || {};
  return createRenderer(_objectSpread(_objectSpread({}, options), {}, {
    enhancers: [sortClassnames(), sortMediaQueryMobileFirst()].concat(_toConsumableArray(options.enhancers || [])),
    plugins: [responsiveObjectValue(responsiveProps), extend(), embedded(), responsiveValue(getResponsiveMediaQueries, responsiveProps), prefixer(), falllbackValue(), unit(), namedKeys(function (props) {
      return props && props.theme && props.theme.breakpoints || {};
    }), themeFontsPlugin, hexToRgbaPlugin, rtl(isRtl ? 'rtl' : 'ltr'), themeValue({
      color: function color(theme) {
        return theme.color;
      },
      backgroundColor: function backgroundColor(theme) {
        return theme.color;
      }
    })].concat(_toConsumableArray(options.plugins || [])).filter(Boolean)
  }));
} // TODO: move to fela repo as an official plugin

function themeFontsPlugin(style, type, renderer, props) {
  var fonts = props.theme && props.theme.fonts || [];
  var fontsPath = props.theme && props.theme.fontsPath || '';

  for (var property in style) {
    var value = style[property]; // TODO: maybe we wanna cache already rendered fonts
    // but no high prio as Fela does that as well

    if (typeof value === 'string' && property === 'fontFamily') {
      (function () {
        // check each alternative font value
        var fontValues = value.split(',');
        var usedFonts = fonts.filter(function (font) {
          return fontValues.indexOf(font.fontFamily) !== -1;
        });

        if (usedFonts.length > 0) {
          usedFonts.forEach(function (_ref2) {
            var fontFamily = _ref2.fontFamily,
                src = _ref2.src,
                fontProps = _objectWithoutProperties(_ref2, ["fontFamily", "src"]);

            return renderer.renderFont(fontFamily, src.map( // allow absolute files with http prefix
            function (file) {
              return (file.indexOf('http') === -1 ? fontsPath : '') + file;
            }), fontProps);
          });
        }
      })();
    } else if (_typeof(value) === 'object' && !Array.isArray(value)) {
      themeFontsPlugin(value, type, renderer, props);
    }
  }

  return style;
} // TODO: move to fela repo as an official plugin


function hexToRgbaPlugin(style) {
  for (var property in style) {
    var value = style[property];

    if (typeof value === 'string' && value.indexOf('#') === 0 && value.length === 9) {
      style[property] = hexToRgba(value);
    } else if (_typeof(value) === 'object' && !Array.isArray(value)) {
      hexToRgbaPlugin(value);
    }
  }

  return style;
} // TODO: move to fela repo as an official plugin


function resolveResponsiveObjectValues(style, properties) {
  var _loop = function _loop(property) {
    if (properties[property]) {
      var value = style[property];

      if (_typeof(value) === 'object' && !Array.isArray(value)) {
        var defaultValue = value.default,
            mediaValues = _objectWithoutProperties(value, ["default"]);

        assignStyle(style, _defineProperty({}, property, defaultValue), {
          extend: [mapValueToMediaQuery(mediaValues, function (value) {
            return _defineProperty({}, property, value);
          })]
        });
      }
    }
  };

  for (var property in style) {
    _loop(property);
  }

  return style;
}

function responsiveObjectValue() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (style) {
    return resolveResponsiveObjectValues(style, properties);
  };
}